import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getRegistroSalidas= async (fechaStart,fechaEnd , idDropoff) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/salidas?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}&idDropoff=${idDropoff}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearRegistroSalida = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/salidas', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateRegistroSalida = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/salidas/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteRegistroSalida = (Id) => Axios.delete(`/salidas/${Id}`);